export default {
  headerContent: {
    title: 'Türkiye Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Turkiye Sigorta İş Yeri Sigortası',
    description: {
      title: 'Turkiye Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'Bir işletmenin devamlılığını korumak zor ve risklidir. İşletme işletildiği süre boyunca birçok riskle karşı karşıyadır. Bu riskler yangın, hırsızlık, sel ve su baskını olarak daha çok sayılabilir. Türkiye Sigorta iş yeri sigortası ile karşılaşabileceğiniz risklere karşı koruma sağlamaktadır.',
        'Türkiye Sigorta sunmuş olduğu bu güvence ile işletmeleri büyümelerine olanak sağlamaktadır.'
      ]
    },
    subContent: {
      title: '',
      content: [
        {
          paragraph: '',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Turkiye Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Turkiye Sigorta İş Yeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'Ana Teminatlar;',
          subList: [
            'Yangın, Yıldırım, İnfilak',
            'Deprem Ve Yanardağ Püskürmesi',
            'Grev, Lokavt, Kargaşalık, Halk Hareketleri, Kötü Niyetli Hareketler, Terör',
            'Diğer Yangın Ek Teminatları',
            'Dolu',
            'Yangın Mali Mesuliyet',
            'Cam Kırılması',
            'Hırsızlık',
            'Kasa Hırsızlık',
            'Kar Kaybı',
            'Kira Kaybı',
            'Alternatif İşyeri Masrafları',
            'İş Durması',
            'Kazaen Kırılma',
            'Taşınmaza Bağlı Hukuksal Koruma',
            'Elektrik Hasarları',
            'Ferdi Kaza',
            'Taşınan Para Hırsızlık',
            'Emniyeti Suiistimal',
            'Üçüncü Şahıs Mali Mesuliyet',
            'İşveren Mali Mesuliyet',
            'Elektronik Cihaz',
            'Makine Kırılması Teminatıdır.'
          ]
        }
      ]
    },
    {
      title: 'Turkiye Sigorta İş Yeri Sigortası Paketleri Nelerdir?',
      content: [
        {
          paragraph:
            'Turkiye Sigorta müşterilerine sektöre göre paket sunmaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong>Bu paketler;</strong>',
          subList: [
            'İşyeri Ekstra Sigortası',
            'Kapsamlı İşyeri Sigortası',
            'Eczane Paket Sigortası',
            'Otel Paket Sigortası',
            'Akaryakıt Paket Sigortası',
            'Oto Plaza Paket Sigortası'
          ]
        }
      ]
    },
    {
      title: 'İş Yeri Ekstra Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Dahili Su',
            'Sel - Su Baskını',
            'Fırtına',
            'Duman',
            'Yer Kayması',
            'Kar Ağırlığı',
            'Kara Ve Hava Taşıtları Çarpması',
            'Dolu',
            'Grev, Lokavt, Kargaşalık, Halk Hareketleri',
            'Kötü Niyetli Hareketler',
            'Terörizm',
            'Hırsızlık',
            'Hasar Nedeniyle Yapılacak Alternatif İş Yeri Değişikliği Masrafları',
            'Enkaz Kaldırma Masrafları (Hasardan Sonra Oluşan Enkazın Kaldırılma Masrafları)',
            'İş Durması',
            'Çalışanlara Ait Eşyalar',
            'Cam Kırılması'
          ]
        },
        {
          paragraph:
            'Ek Teminatlar;',
          subList: [
            'Taşınan para sigortası',
            'Emniyeti suistimal sigortası',
            'İşveren mali sorumluluk sigortası',
            'Üçüncü şahıs mali sorumluluk sigortası',
            'İş yeri sahibine ve/veya çalışanlarına ferdî kaza sigortası',
            'Elektronik cihaz sigortası',
            'Makine kırılması',
            'Nakliyat emte sigortası',
            'Geçici inşaat, tadilat, ek bina ve montaj işleri için inşaat / montaj tüm riskler sigortası',
            'Hukuksal koruma',
            'Acil sağlık hizmetleri'
          ]
        }
      ]
    },
    {
      title: 'Kapsamlı İş Yeri Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Yangın, yıldırım, infilak',
            'Deprem ve yanardağ püskürmesi',
            'Grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler, terör',
            'Diğer yangın ek teminatları',
            'Dolu',
            'Yangın mali mesuliye',
            'Cam kırılması',
            'Hırsızlık',
            'Kar kaybı',
            'Kira kaybı',
            'Alternatif işyeri masrafları',
            'İş durması',
            'Kazaen kırılma',
            'Taşınmaza bağlı hukuksal koruma',
            'Elektrik hasarları',
            'Ferdi kaza',
            'Kasa hırsızlık',
            'Taşınan para hırsızlık',
            'Emniyeti suiistimal',
            'Üçüncü şahıs mali mesuliyet',
            'İşveren mali mesuliyet',
            'Elektronik cihaz',
            'Taşınabilir cihaz',
            'Makine kırılması',
            'Hareketli makineler için geniş kasko',
            'Makine kırılmasına bağlı ürün bozulması'
          ]
        }
      ]
    },
    {
      title: 'Eczane Paket İş Yeri Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Yangın, yıldırım, infilak',
            'Deprem ve yanardağ püskürmesi,',
            'Grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler, terör',
            'Diğer yangın ek teminatları',
            'Kira kaybı',
            'Yangın mali sorumluluk',
            'Alternatif eczane masrafları',
            'İş durması,',
            'Hırsızlık',
            'Cam kırılması',
            'Kasa hırsızlık',
            'Üçüncü şahıs mali sorumluluk',
            'Eczane mesleki sorumluluk',
            'Ferdi kaza',
            'Elektronik cihaz',
            'İşveren mali sorumluluk '
          ]
        }
      ]
    },
    {
      title: 'Otel Paket İş Yeri Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Yangın, yıldırım, infilak',
            'Grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler, terör',
            'Diğer yangın ek teminatları',
            'Deprem',
            'Alternatif otel masrafları',
            'Yangın mali sorumluluk',
            'İş durması',
            'Hırsızlık',
            'Cam kırılması',
            'Kâr kaybı',
            'Kira kaybı',
            'Ferdi kaza',
            'İş durması',
            'Kazaen kırılma',
            'Taşınmaza bağlı hukuksal koruma',
            'Elektrik hasarları',
            'Otel mali sorumluluk ve ek teminatlar',
            'İşveren mali sorumluluk ve ek teminatlar',
            'Taşınan para sigortası',
            'Emniyeti suiistimal',
            'Ana kasa hırsızlık',
            'Elektronik cihaz',
            'Taşınabilir cihaz',
            'Makine kırılması',
            'Hareketli makineler için geniş kasko',
            'Makine kırılmasına bağlı ürün bozulması',
            'Makine kırılmasına bağlı kar kaybı',
            'Taşınmaza bağlı hukuksal koruma'
          ]
        }
      ]
    },
    {
      title: 'Akaryakıt Paket İş Yeri Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Yangın',
            'Deprem ve yanardağ püskürmesi',
            'Grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler, terör',
            'Diğer yangın ek teminatları',
            'Yangın mali sorumluluk',
            'İş durması',
            'Hırsızlık',
            'Kasa hırsızlık',
            'Cam kırılması',
            'Yer altı tank ve tesisatının delinmesi sonucu mal kaybı',
            'Emniyeti suiistimal',
            'Taşınan para',
            'Pompacı nakit hırsızlık',
            'Ferdi kaza',
            'Üçüncü şahıs sorumluluk',
            'İşveren mali sorumluluk',
            'Tanklara yanlış dolum',
            'Çevre kirliliği sorumluluk',
            'Hatalı ürün verilmesinden kaynaklanan sorumluluk',
            'Makine kırılması',
            'Elektronik cihazlar'
          ]
        }
      ]
    },
    {
      title: ' Oto Plaza İş Yeri Sigortası Nedir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Yangın',
            'Deprem ve yanardağ püskürmesi',
            'Grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler, terör',
            'Diğer yangın ek teminatlar',
            'Yangın mali sorumluluk',
            'Kira kaybı',
            'Kar kaybı',
            'İş durması',
            'Alternatif işyeri masrafları',
            'Hırsızlık',
            'Kasa hırsızlık',
            'Çalışanların kişisel eşyalar',
            'Araç çarpması',
            'Cam kırılması',
            'Emniyeti suiistimal',
            'Taşınan para',
            'Ferdi kaza',
            'Üçüncü şahıs sorumluluk',
            'İşveren mali sorumluluk',
            'Tamirhane mali sorumluluk',
            'Mesleki sorumluluk',
            'Taşınmaza bağlı hukuksal koruma',
            'Test tanıtım sürüşleri ve araç nakli',
            'Teşebbüs sahibi (satış/servis) zorunlu mali sorumluluk',
            'Makine kırılması',
            'Elektronik cihazlar'
          ]
        }
      ]
    },
    {
      title: 'Turkiye Sigorta İş Yeri Sigortası İçin Gerekli Bilgiler (Evraklar) Nelerdir?',
      content: [
        {
          paragraph:
            'İş yeri sigortasının doğru düzenlenebilmesi için kesin olan bilgilere gerek vardır.',
          subList: null
        },
        {
          paragraph:
            'İstenen belgeler;',
          subList: [
            'İşletme tüzel kişilik ise işletmenin vergi numarası',
            'İşletme şahıs şirketi ise işyeri sahibi TC’si',
            'İş yeri içerisinde bulunan emtea bedelleri',
            'Dekorasyon ve demirbaş bedelleri',
            'İş yerinde bulunan cam bedelleri',
            'İş yeri yangın güvenlik önlemleri',
            'İş yeri hırsızlık güvenlik önlemleri bilgileri istenmektedir.'
          ]
        }
      ]
    },
    {
      title: 'Turkiye Sigorta İş Yeri Sigortası Alırken Nelere Dikkat Edilmelidir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası hesaplaması sigortalının beyanına göre yapılmaktadır. Bu sebeple sigorta uzmanın sizden istemiş olduğu bilgi ve belgeleri kesin ve eksiksiz iletmeniz gerekmektedir. İletmiş olduğunuz bilgi ve belgeler ile size özel olarak iş yeri sigortası teklifi hazırlanmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Gelen teklif üzerinde yazan teminat, sigortalı bilgiler, özel ve genel şartları okuyarak poliçe hakkında bilgi sahibi olabilir ve sigortanın size uygunluğunu kontrol edebilirsiniz. Kontrolünüz sonucunda poliçe size uygun ise poliçe tanziminde bulunabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta En Uygun İş Yeri Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'İş yeri sigortası fiyatları işletmeler arasında farklılık göstermektedir. Bunun nedeni tüm sektörde risk oranlarının farklı olmasından kaynaklanmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Size özel teklif için başvuru formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Fiyat Teklifi Online Nasıl Alınır?',
      content: [
        {
          paragraph:
            'İş yeri teklifinizi gelişen teknoloji ile online olarak alabilmeniz mümkündür.',
          subList: null
        },
        {
          paragraph:
            'Alokasko olarak siz sigortalılarımıza dakikalar içerisinde iş yeri sigortanızı online olarak alabilmenizi sağlamaktayız.',
          subList: null
        },
        {
          paragraph:
            'Online teklif almak için alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
